module.exports = __webpack_public_path__ + "img/ico_biaoqianjianzaoyanfa.77ea3d3a.png";